import { AllLeaguesSchema } from '@/views/sports/AllLeagues/styles/AllLeagues.styles';

export const allLeaguesStyles: AllLeaguesSchema = {
  accordionButton: {
    color: 'gray.700',
    sx: {
      display: 'flex',
      p: '3',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      borderTopRadius: 'md',
      border: 'none',
      borderTopColor: 'var(--bc-beta-200, #4B5A6D)',
      bgGradient: 'linear(to-b, zeta.400, zeta.600)',
      fontSize: 'sm',

      _hover: {
        bgGradient: 'linear(to-b, zeta.500, zeta.600)',
      },
    },
  },
  boxWrapper: {
    mt: '0',
  },
  topLeaguesText: {
    color: 'alpha.600',
    flex: '1',
    textAlign: 'left',
    fontWeight: 'semibold',
  },
  accordionIcon: { color: 'alpha.600' },
  accordionPanel: {
    bgGradient: 'linear(to-b, zeta.400, zeta.600)',
    pb: 3,
    borderBottomRadius: 'md',
  },
  accordionPanelBoxWrapper: {
    borderLeftWidth: '3px',
    borderColor: 'alpha.400',
    px: '2',
  },
  accordionPanelBoxInner: {
    mb: '2',
  },
  accordionPanelBoxInnerLink: {
    color: 'alpha.600',
    fontWeight: 'semibold',
    fontSize: 'sm',
    sx: { _hover: { textDecoration: 'none' } },
  },
  marketGroupsByLetterHeadingText: {
    sx: {
      color: 'white',
      fontsize: 'md',
      my: '3',
      fontWeight: 'bold',
    },
  },
  marketGroupsByLetterAccordionItem: {
    border: 'none',
    sx: {
      _last: {
        button: {
          _last: {
            borderBottomRadius: 'md',
          },
        },
      },
      _first: {
        button: {
          _first: { borderTopRadius: 'md', border: 'none' },
        },
      },
    },
  },
  marketGroupsByLetterAccordionButton: {
    color: 'gray.700',
    sx: {
      display: 'flex',
      p: '3',
      gap: '2',
      alignItems: 'center',
      alignSelf: 'stretch',
      borderTopWidth: '1px',
      borderTopColor: '#353f4e',
      borderRadius: 'unset',
      bgGradient: 'linear(to-b, zeta.400, zeta.600)',
      _hover: {
        bgGradient: 'linear(to-b, zeta.500, zeta.600)',
      },
      '&&&': {
        _expanded: {
          borderBottomLeftRadius: 'none',
          borderBottomRightRadius: 'none',
        },
      },
    },
  },
  marketGroupsByLetterTitleText: {
    color: 'alpha.600',
    flex: '1',
    textAlign: 'left',
    fontWeight: 'semibold',
  },
  marketGroupsByLetterCountryFlag: {
    marginRight: '10px',
    width: '1.2em',
    height: '1.2em',
  },
  marketGroupsByLetterAccordionIcon: {
    color: 'gray.700',
  },
  marketGroupsByLetterAccordionPanel: {
    bgGradient: 'linear(to-b, zeta.400, zeta.600)',
    pb: 4,
    borderBottomRadius: 'md',
  },
  marketGroupsByLetterAccordionPanelBox: {
    borderLeftWidth: '3px',
    borderColor: 'alpha.400',
    px: '2',
  },
  marketGroupsByLetterAccordionPanelLink: {
    color: 'alpha.600',
    fontSize: 'sm',
    fontWeight: 'semibold',
    sx: { _hover: { textDecoration: 'none' } },
  },
  headerSportText: {
    fontFamily: 'SkranjiBold',
    fontWeight: 'normal',
    fontSize: 'xl',
    textTransform: 'uppercase',
  },
  navWrapper: {
    pb: '4',
    mb: '3',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderColor: '#192B3B',
    borderRadius: 'none',
    boxShadow: '0px 1px 0px 0px #FFFFFF12',
  },
};
